export default __webpack_public_path__ + "static/media/ibm-mq.2cae924a.svg";